var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "40px",
    viewBox: "0 0 50 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-Folder-White",
    transform: "translate(-5.000000, -10.000000)",
    fill: "#F3F3F3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,10 L10,10 C7.25,10 5.025,12.25 5.025,15 L5,45 C5,47.75 7.25,50 10,50 L50,50 C52.75,50 55,47.75 55,45 L55,20 C55,17.25 52.75,15 50,15 L30,15 L25,10 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderWhite);
export default __webpack_public_path__ + "static/media/folder-white.f2e8d92078c0254c9f58d186f7078b1f.svg";
export { ForwardRef as ReactComponent };